import { decode } from "html-entities";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { dispatch } from "../../store";
import { EmptyImage } from "../../utils/constants";
import { cart } from "../../store/models";

export default function CartMenuItem({ item }) {
  const cartStore = useSelector((state) => state.cart);
  const id = `${item?.productId}__${item?.selectedVariation}`;

  return (
    <li className="item d-flex justify-content-center align-items-center">
      <Link to="/" className="product-image">
        <img
          className="lazyload"
          src={item?.productImageUrl || item?.productImages[0]?.productImageUrl}
          data-src={
            item?.productImageUrl || item?.productImages[0]?.productImageUrl
          }
          alt={item?.productName}
        />
      </Link>
      <div className="product-details">
        <Link to="/" className="product-title">
          {item?.productName}
        </Link>
        <div className="variant-cart">{item?.selectedVariation}</div>
        <div className="priceRow mt-1">
          <div className="product-price">
            <span className="money">
              {decode("&#8358;")} {item?.productPrice}
            </span>
          </div>
        </div>
      </div>
      <div className="qtyDetail text-center">
        <div className="wrapQtyBtn">
          <div className="qtyField">
            <button
              className="qtyBtn minus"
              onClick={() => dispatch.cart.decreaseUnit(id)}>
              <i className="icon an an-minus-r" aria-hidden="true"></i>
            </button>
            <input
              contentEditable={false}
              type="number"
              name="quantity"
              value={cartStore[id].unit}
              className="qty"
            />
            <button
              className="qtyBtn plus"
              onClick={() => dispatch.cart.increaseUnit(id)}>
              <i className="icon an an-plus-l" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <button className="remove" onClick={() => dispatch.cart.removeItem(id)}>
          <i
            className="an an-times-r"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Remove"></i>
        </button>
      </div>
    </li>
  );
}
